import React from 'react'
import { Places } from './Places'
import { SpotLight } from './SpotLight'

const Home2 = () => {
  return (
    <div>
        <SpotLight/>
        <Places/>
    </div>
  )
}

export default Home2